import _ from "lodash";

import {
  DestinationStandardMapping,
  DestinationStandardMappingItemProperty,
} from "../types";

const contentsTikTokProperties: DestinationStandardMappingItemProperty[] = [
  {
    key: "content_type",
    exampleValue: "product",
    allowedValues: ["product", "product_group"],
    type: "string",
    description:
      "Either product or product_group based on the content_ids or contents being passed. If the IDs" +
      " being passed in content_ids or contents parameter are IDs of products then the value should be product. " +
      "If product group IDs are being passed, then the value should be product_group. Use only for top-level content (not in contents array).",
  },
  {
    key: "content_id",
    exampleValue: "ABC123",
    type: "string",
    description:
      "Product ID, such as a SKU. Use only for top-level content (not in contents array).",
  },
  {
    key: "quantity",
    exampleValue: 4.5,
    type: "number",
    description:
      "Quantity of the item specified by content_id. Use only for top-level content (not in contents array).",
  },
  {
    key: "contents",
    exampleValue: [
      {
        content_id: "ABC123",
        quantity: 2,
      },
      {
        content_id: "XYZ789",
        quantity: 3,
      },
    ],
    type: "array",
    description:
      "An array of JSON objects that contains the quantity and the International Article Number (EAN)" +
      " when applicable, or other product or content identifier(s).",
  },
];

const valueMetadataTikTokProperties: DestinationStandardMappingItemProperty[] =
  [
    {
      key: "currency",
      exampleValue: "USD",
      type: "string",
      description: "The currency for the value specified.",
      additionalTransformation: {
        operation: "uppercasePropertyValue",
      },
    },
    {
      key: "value",
      exampleValue: 45.5,
      type: "number",
      description: "The value of a user performing this event to the business.",
      additionalTransformation: {
        operation: "castPropertyValue",
        operandValue: "number",
      },
    },
    {
      key: "description",
      exampleValue: "Lightweight cotton",
      type: "string",
      description: "Description of the item or page.",
    },
  ];

const tikTokStandardMapping: DestinationStandardMapping = {
  wildcard: {
    propertiesArr: [],
  },
  items: [
    {
      eventName: "AddPaymentInfo",
      description: "When payment information is added in the checkout flow.",
      propertiesArr: [],
    },
    {
      eventName: "AddToCart",
      description: "When a product is added to the shopping cart.",
      propertiesArr: _.concat(
        contentsTikTokProperties,
        valueMetadataTikTokProperties,
      ),
    },
    {
      eventName: "AddToWishlist",
      description: "When a product is added to a wishlist.",
      propertiesArr: [],
    },
    {
      eventName: "ClickButton",
      description: "When a button is clicked.",
      propertiesArr: [],
    },
    {
      eventName: "CompletePayment",
      description: "When a payment is completed.",
      propertiesArr: _.concat(
        contentsTikTokProperties,
        valueMetadataTikTokProperties,
      ),
    },
    {
      eventName: "CompleteRegistration",
      description: "When a registration form is completed.",
      propertiesArr: [],
    },
    {
      eventName: "Contact",
      description:
        "When a person initiates contact with your business via telephone, SMS, email, chat, etc.",
      propertiesArr: [],
    },
    {
      eventName: "Download",
      description:
        "When a button to open an external browser download page is clicked.",
      propertiesArr: [],
    },
    {
      eventName: "InitiateCheckout",
      description:
        "When a person enters the checkout flow prior to completing the checkout flow.",
      propertiesArr: [],
    },
    {
      eventName: "PlaceAnOrder",
      description: "When an order is placed.",
      propertiesArr: _.concat(
        contentsTikTokProperties,
        valueMetadataTikTokProperties,
      ),
    },
    {
      eventName: "Search",
      description: "When a search is made.",
      propertiesArr: [],
    },
    {
      eventName: "Subscribe",
      description: "When a subscription is made.",
      propertiesArr: [],
    },
    {
      eventName: "SubmitForm",
      description: "When a form is submitted.",
      propertiesArr: [],
    },
    {
      eventName: "ViewContent",
      description:
        "A visit to a web page you care about (for example, a product page or landing page).",
      propertiesArr: _.concat(
        contentsTikTokProperties,
        valueMetadataTikTokProperties,
      ),
    },
  ],
};

export const getTikTokStandardMapping = async () => {
  return tikTokStandardMapping;
};
